import { BehaviorSubject, Subject } from "rxjs";

export class LanguageService {
    public static Languages: BehaviorSubject<any[]> = new BehaviorSubject(null);
    public static SelectedLanguage: BehaviorSubject<any> = new BehaviorSubject(null);
    public static LanguageChanged: Subject<any> = new Subject();
}
